import type { LucideIcon } from 'lucide-react';
import { AlertTriangleIcon, CpuIcon, LogOutIcon, SkullIcon, TimerIcon } from 'lucide-react';

export type DeviceLogType = 'crash' | 'anr' | 'native' | 'error' | 'abnormal_exit';

export const DEVICE_LOG_TYPES: DeviceLogType[] = ['crash', 'anr', 'native', 'error', 'abnormal_exit'];

export interface DeviceLogTypeMeta {
	label: string;
	borderClass: string;
	badgeClass: string;
	icon: LucideIcon;
}

export const DEVICE_LOG_TYPE_META: Record<DeviceLogType, DeviceLogTypeMeta> = {
	crash: {
		label: 'Краш',
		borderClass: 'border-l-destructive',
		badgeClass: 'bg-destructive/15 text-destructive',
		icon: SkullIcon,
	},
	anr: {
		label: 'ANR',
		borderClass: 'border-l-orange-500',
		badgeClass: 'bg-orange-500/15 text-orange-500',
		icon: TimerIcon,
	},
	native: {
		label: 'Native',
		borderClass: 'border-l-violet-500',
		badgeClass: 'bg-violet-500/15 text-violet-500',
		icon: CpuIcon,
	},
	error: {
		label: 'Ошибка',
		borderClass: 'border-l-chart-3',
		badgeClass: 'bg-chart-3/15 text-chart-3',
		icon: AlertTriangleIcon,
	},
	abnormal_exit: {
		label: 'Аварийный выход',
		borderClass: 'border-l-muted-foreground',
		badgeClass: 'bg-muted text-muted-foreground',
		icon: LogOutIcon,
	},
};

export function getDeviceLogTypeMeta(logType: string): DeviceLogTypeMeta {
	return DEVICE_LOG_TYPE_META[logType as DeviceLogType] ?? {
		label: logType,
		borderClass: 'border-l-border',
		badgeClass: 'bg-muted text-muted-foreground',
		icon: AlertTriangleIcon,
	};
}
